import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid
} from "@mui/material";
import Select, { components } from "react-select";
import ProductCard from '../components/ProductCard';
// import "../components/PopularProducts.css";
import product1 from '../assests/product1.png';
import product2 from '../assests/product2.png';
import product3 from '../assests/product3.png';
import DropDown from "../components/DropDown";
import showIcon from "../assests/showIcon.png";
import filterIcon from "../assests/filterIcon.png";

const selectOptions = [
  { value: "50", label: "Show 50" },
  { value: "20", label: "Show 20"}
];
const selectOptions2 = [
  { value: "sort by featured", label: "Sort by Featured" },
  { value: "equipment", label: "Equipment" },
  { value: "pharmacy", label: "Pharmacy"}
];

const CustomOption = (props) => (
  <components.Option {...props} className="rangefilter-option">
    {props.data.label}
  </components.Option>
);

const Wishlist = () => {
    

//   data 
const productDetails = [
  {
    image:product1,
    name: "Equipment",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Dental',
    discountPrice:'$55.8',
    tag:'Hot',
  },
  {
    image:product2,
    name: "VIVO  Galaxy phone S9 Ultra",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Medical',
  },
 {
    image:product3,
    name: "Equipment",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Dental',
  },
  {
    image:product2,
    name: "VIVO  Galaxy phone S9 Ultra",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Medical',
    discountPrice:'$55.8',
  },
  {
    image:product1,
    name: "Equipment",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Dental',
    discountPrice:'$55.8',
  },
  {
    image:product2,
    name: "VIVO  Galaxy phone S9 Ultra",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Medical',
  },
 {
    image:product3,
    name: "Equipment",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Dental',
    tag:'Hot',
  },
  {
    image:product2,
    name: "VIVO  Galaxy phone S9 Ultra",
    ratingNumber: 201,
    by:"ZK Pharma",
    price:"$228.85",
    category:'Medical',
    discountPrice:'$55.8',
  },
  ];

  // dropdown 
 const [selectedValue, setSelectedValue] = useState(selectOptions[0]);

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <img src={showIcon} alt="icon" />
      {children}
    </components.SingleValue>
  );
  // filter 
  const [selectedValue2, setSelectedValue2] = useState(selectOptions2[0]);
   const handleChange2 = (value) => {
    setSelectedValue2(value);
  };
   const SingleValue2 = ({ children, ...props }) => (
    <components.SingleValue {...props}>
     <img src={filterIcon} alt="icon" />
      {children}
    </components.SingleValue>
  );
  // dropdown 
    return (
        <Box sx={{padding:'70px 0 80px'}}>
          <Container
              maxWidth="xl">
                    <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'space-between',
                         marginBottom: "30px",
                    }}>
                         <Typography className="titleSec" sx={{
         
        }}>We Found 15 Items for You</Typography> 
        <Box sx={{
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'space-between',
                        gap:"12px",
                    }}>
          <DropDown
        selectedValue={selectedValue}
        selectOptions={selectOptions}
        CustomOption={CustomOption}
        handleChange={handleChange}
        SingleValue={SingleValue}
      />
      <DropDown
        selectedValue={selectedValue2}
        selectOptions={selectOptions2}
        CustomOption={CustomOption}
        handleChange={handleChange2}
        SingleValue={SingleValue2}
      />
        </Box>
                    </Box>
                    <Grid container spacing={2}>
                
            {productDetails.map((productDetail, index) => (    
                <Grid item size={{ xs: 12, sm: 6, md:3, lg:2 }}>     
 {/* <TabPanel> */}
    <ProductCard key={index} productDetail={productDetail} />
    {/* </TabPanel> */}
    
      </Grid>
      
      ))}
                </Grid>
            </Container>
        </Box>
    );
}

export default Wishlist;
